import {
  FeatureName,
  useCurrentAccount,
  useCurrentWorkspace,
  useIsFeatureEnabled,
  useIsFeatureEnabledFunc,
} from '@gripp/shared-logic';
import { useCallback } from 'react';
import { IMenu, MenuItems } from '../components/menuItems';
import { MenuItems as MenuItemsOld } from '../components/menuItems-old';

export const useMenuPermission = () => {
  const { account } = useCurrentAccount();
  const workspace = useCurrentWorkspace(true);
  const isFeatureEnabled = useIsFeatureEnabledFunc();

  // TODO: Crop Circle Redesign | Feature Flag can be removed after the release
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);
  const menuItems = isCropCircleRedesignEnabled ? MenuItems : MenuItemsOld;

  const menuList = useCallback(
    (): IMenu[][] =>
      menuItems.map((group) =>
        group.filter((link) => {
          if (link.requiredFeature && !isFeatureEnabled(link.requiredFeature)) {
            return false;
          }

          if (
            link.requiredWorkspaceType &&
            workspace?.type !== link.requiredWorkspaceType
          ) {
            return false;
          }

          const isWorkspaceRequired =
            typeof link.isWorkspaceRequired === 'function'
              ? link.isWorkspaceRequired(account)
              : link.isWorkspaceRequired;

          if (isWorkspaceRequired && !workspace) {
            return false;
          }

          return (
            link.requiredPermission &&
            account?.hasPermission(link.requiredPermission)
          );
        })
      ).filter((items) => items.length > 0),
    [isFeatureEnabled, account, workspace]
  );

  return menuList;
};
